import { IEventDetail } from "interfaces";
import { LANGUAGES } from "utills/constants";

export const ChooseLanguage = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  return (
    <div className="box-container">
      {LANGUAGES.map((language, index) =>
        (eventDetailData?.languages ?? []).includes(language.value) ? (
          <div
            className="flex flex-row items-center gap-x-1.5 font-medium text-sm [&:not(:first-child)]:mt-2"
            key={index}
          >
            <img
              src={language.icon}
              className="rounded-full w-5 h-5"
              alt="flag"
            />{" "}
            {language.label}
          </div>
        ) : (
          <div key={index}></div>
        )
      )}
    </div>
  );
};
